// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if ({"src_themes_reactwp_js_templates_Default_jsx":1,"src_themes_reactwp_js_templates_NotFound_jsx":1}[chunkId]) return "reactwp/assets/js/chunks/" + chunkId + ".js";
	// return url for filenames based on template
	return undefined;
};